import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEstudo,
} from '../../../business-components/Card/Card'

import {
    CardGridEstudoTabelaPadrao,
} from '../estudo-form/EstudoComp'

import PrevidenciaPrivadaFormPrevidenciaPrivada from './PrevidenciaPrivadaFormPrevidenciaPrivada'



const PrevidenciaPrivadaForm = ( { variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, handleSubmitAutomatico,
    estudo, vars, linhaFormList, tabClienteFormList, arquivoList, obterArquivoList } ) => {

    const CardGridEstudoAux = values.modoApresentacao ? GridItem12 : CardGridEstudo
    


    return (
        <GridContainer
            className='justify-center'
        >
            <GridItem11>
                <CardGridEstudoAux>
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={''}
                        label={LABEL.analiseBeneficiosPrevidenciaPrivada}
                        helpTextMorte={''}
                        helpTextInvalidez={''}
                        component={
                            <PrevidenciaPrivadaFormPrevidenciaPrivada
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                vars={vars}
                                linhaFormList={linhaFormList}
                                tabClienteFormList={tabClienteFormList}
                                arquivoList={arquivoList}
                                obterArquivoList={obterArquivoList}
                            />
                        }
                        popup={false}
                    />
                </CardGridEstudoAux>
            </GridItem11>
        </GridContainer>
    )
}

export default PrevidenciaPrivadaForm